import script from "./STK32_001INS.vue?vue&type=script&setup=true&lang=js"
export * from "./STK32_001INS.vue?vue&type=script&setup=true&lang=js"

import "./STK32_001INS.vue?vue&type=style&index=0&id=1618a6fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1618a6fb"]])

export default __exports__